// Calendar-month helpers carved out of controllers/index.js.
// The two DOM helpers drive power-calendar's day buttons via an `available`
// attribute, which the stylesheet keys off; there is no component API for it.

import moment from 'moment-timezone';

export function clearCalendarAvailability() {
  document.querySelectorAll('button.ember-power-calendar-day').forEach((el) => {
    el.setAttribute('available', false);
  });
}

export function markCalendarAvailability(dates) {
  dates.forEach((date) => {
    document
      .querySelectorAll(`button.ember-power-calendar-day[data-date='${date}']`)
      .forEach((el) => {
        el.setAttribute('available', true);
      });
  });
}

// Start/end of the month containing `date`, expressed in the booking timezone.
export function monthRange(date, timeZone) {
  const momentDate = moment(date);

  return {
    from_date: momentDate.startOf('month').tz(timeZone).format('YYYY-MM-DDTHH:mmZ'),
    to_date: momentDate.endOf('month').tz(timeZone).format('YYYY-MM-DDTHH:mmZ'),
  };
}
